import { getColumns, getKeys, getRows } from '../../../components/form/ExceptionBreakdownInput';
import type { Page } from '../../types';
import { type GradeValue, gradeValueToLabel } from '../../utils/csc';

const columns = getColumns();
const rows = getRows().map((row) => ({
  name: row,
  label: gradeValueToLabel(row as GradeValue),
}));

const exceptionsBreakdown: Page[] = [
  {
    pageType: 'question',
    title: 'Breakdown',
    name: 'fair-and-open-breakdown',
    hidePageTitle: true,
    description: 'Please provide a breakdown of each exception by grade',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'inset',
        title: '',
        insetContent:
          "Please see the below key for the table's column headings<br><br>" +
          'Example: <b>Column 5</b> in the table relates to <b>Exception 5: Former civil servants</b> from the list below<br><br>' +
          'Exception 1: Temporary appointments<br>' +
          'Exception 2: Support for government employment programmes<br>' +
          'Exception 3: Secondments<br>' +
          'Exception 4: Highly specialist skills<br>' +
          'Exception 5: Former civil servants<br>' +
          'Exception 6: Interchange with the Northern Ireland Civil Service<br>' +
          'Exception 7: Transfers of staff from public bodies<br>' +
          'Exception 8: Transfer of organisations into the Civil Service - non-TUPE<br>' +
          'Exception 9: Transfer of organisations into the Civil Service - TUPE<br>' +
          'Exception 10: Conversion to permanency: administrative & industrial grades<br>',
        name: 'external-recruit-exceptions-breakdown-inset',
        detailsContent: 'Key contact 2 email address',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'exceptionBreakdownInput',
        title: 'Breakdown',
        name: 'exception-breakdown-input-details',
        detailsHeading: 'More information',
        detailsContent: 'If the grade does not align directly you can use the equivalent',
        rules: {
          required: true,
        },
        customValidation: {
          sumEqualToPreviousAnswer: 'headline-exceptions',
          fieldsEqual: rows.map((row) => ({
            fields: columns.map((column) => `${row.name}${column}`),
            answer: 'exception-grade-column',
            answerValue: row.name,
            errorPrefix: `The total of ${row.label} exceptions must equal`,
          })),
        },
      },
      {
        questionType: 'textInputSmall',
        title: 'Total',
        name: 'exception-breakdown-total',
        // detailsContent: 'Key contact 2 email address',
        rules: {
          required: true,
        },
        customValidation: {
          sumEqualToPreviousAnswer: 'headline-exceptions',
        },
        autoFill: {
          keys: getKeys(),
          field: 'exception-breakdown-input-details',
        },
      },
      {
        questionType: 'textarea',
        name: 'life-chances-respective-schemes',
        title:
          'If you have reported appointments made using Exception 2 (Life Chances), please note the respective schemes below with the number and grade of appointments made under each scheme.',
        rules: {
          required: false,
        },
      },
      {
        questionType: 'textarea',
        name: 'conversion-to-permanency-assessment-process',
        title:
          'If you have reported appointments made using Exception 10 (Conversion to permanency), please note the assessment process used to convert the individual(s) concerned and whether this was approved by the Commission in advance. If converting an Exception 2 (Life chances) appointment using the assessment process set out in the respective scheme, the process has been pre-approved by the Commission and individual approval would not have been required.',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default exceptionsBreakdown;
